<template>
  <div class="secondNav" v-if="items&&items.length">
    <router-link class="link" v-for="(v,i) in items" :key="i" :to="v.to">{{v.text}}</router-link>
  </div>
</template>
<script>
/* 二级导航 */
export default {
  computed:{
    path(){
      return this.$route.path
    },
    items(){
      if(
        this.path=='/assets/recharge'||
        this.path=='/assets/withdraw'
      ){
        return [
          { text: this.$t('nav.w9'), to: { name: "recharge" } },
          { text: this.$t('nav.w10'), to: { name: "withdraw" } },
        ]
      }
      else if(
        this.path=='/assets/domainManage'||
        this.path=='/assets/registrarManage'
      ){
        return [
          { text: this.$t('nav.w13'), to: { name: "domainManage" } },
          { text: this.$t('nav.w16'), to: { name: "registrarManage" } },
        ]
      }
      else if (
        this.path=='/coupon/index' ||
        this.path =='/coupon/exchangeCoupon'
      ) {
        return [
          {text:this.$t('nav.w45'), to:　{name : "coupon"}},
          {text:this.$t('nav.w47'), to:　{name : "exchangeCoupon"}}
        ]
      }
      else if(
        this.path=='/order/investOrder' ||
        this.path =='/order/loanOrder'
      ){
        return [
          {text:this.$t('nav.w23'), to:　{name : "investOrder"}},
          {text:this.$t('nav.w24'), to:　{name : "loanOrder"}}
        ]
      }
      else if(
        this.path=='/message/news' ||
        this.path =='/message/notice'
      ){
        return [
          {text:this.$t('nav.w32'), to:　{name : "notice"}},
          {text:this.$t('nav.w33'), to:　{name : "news"}}
        ]
      }
      return []
    }
  }
};
</script>

<style lang="less" scoped>
.secondNav {
  border-bottom: solid 1px #d7d7d9;
  line-height: 1.5;
  text-align: center;
  margin-bottom: 10px;
  .link {
    display: inline-block;
    padding: 20px 25px;
    font-size: 18px;
    margin: 0 50px;
    color: #232325;
    position: relative;
    &.router-link-exact-active {
      color: #6a98ff;
      &:before {
        position: absolute;
        left: 0;
        bottom: -1px;
        height: 4px;
        background: #6a98ff;
        width: 100%;
        display: block;
        content: "";
      }
    }
  }
}
</style>
